/* eslint-disable @typescript-eslint/ban-types */
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { sharedHttpConstants } from 'src/app/components/shared/sharedConstants/http.constants';
import { httpHeadersType } from '../models/interface/httpHeaders.enum';
import { UserDataService } from './user-data.service';

@Injectable({
  providedIn: 'root',
})
export class MuHttpService {
  private tokenLocal: string;

  constructor(private http: HttpClient, private userDataService: UserDataService) {
    userDataService.getTokenLocal().subscribe(tokenLocal => {
      this.tokenLocal = tokenLocal;
    });
  }

  /*eslint-disable-next-line*/
  private getHeaders(excludeHeadings: boolean, headersIn = {}, headersType: httpHeadersType = httpHeadersType.ALLHEADERS): HttpHeaders {
    let heads = {};
    if (!excludeHeadings) {
      switch (headersType) {
        case httpHeadersType.ALLHEADERS:
          heads = {
            Authorization: this.tokenLocal,
            access_token: this.tokenLocal,
            'access-token': this.tokenLocal,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
          };
          break;
        case httpHeadersType.ONLY_ACCESSTOKEN:
          heads = {
            'access-token': this.tokenLocal,
          };
          break;
        case httpHeadersType.ONLY_ACCESS_TOKEN:
          heads = {
            access_token: this.tokenLocal,
          };
          break;
        case httpHeadersType.ONLY_AUTHORIZATION:
          heads = {
            Authorization: this.tokenLocal,
          };
          break;
      }
    }
    return new HttpHeaders({
      ...headersIn,
      ...heads,
    });
  }
  public get(
    url: string,
    headersIn = {},
    excludeHeadings?: boolean,
    headersType: httpHeadersType = httpHeadersType.ALLHEADERS
  ): Observable<Object> {
    headersIn['Content-Type'] = 'application/json; charset=UTF-8';
    if (url.indexOf('?') > -1) {
      if (url.indexOf('time_stamp') === -1) {
        url = url + '&time_stamp=' + Math.floor(Date.now() / 1000);
      }
    } else {
      url = url + '?time_stamp=' + Math.floor(Date.now() / 1000);
    }
    return this.http.get(url, { headers: this.getHeaders(excludeHeadings, headersIn, headersType), observe: 'response' }).pipe(
      map(res => {
        return res.body;
      }),
      catchError(error => {
        return this.handleError(error);
      })
    );
  }

  public post(
    url: string,
    body: any,
    headersIn = {},
    excludeHeadings?: boolean,
    headersType: httpHeadersType = httpHeadersType.ALLHEADERS
  ): Observable<Object> {
    headersIn['Content-Type'] = 'application/json; charset=UTF-8';
    return this.http.post(url, body, { headers: this.getHeaders(excludeHeadings, headersIn, headersType), observe: 'response' }).pipe(
      map(res => {
        return res.body;
      }),
      catchError(error => {
        return this.handleError(error);
      })
    );
  }

  public postFormData(
    url: string,
    body: any,
    headersIn = {},
    excludeHeadings?: boolean,
    headersType: httpHeadersType = httpHeadersType.ALLHEADERS
  ): Observable<Object> {
    headersIn['Content-Type'] = 'application/x-www-form-urlencoded';
    const headers = !excludeHeadings ? { headers: this.getHeaders(excludeHeadings, headersIn, headersType) } : '';
    return this.http
      .post(url, body, {
        ...headers,
        observe: 'response',
      })
      .pipe(
        map(res => {
          return res.body;
        }),
        catchError(error => {
          return this.handleError(error);
        })
      );
  }

  /**
   * Post object of type formData
   * @param url
   * @param body
   * @param contentType
   * @param headersIn
   * @param excludeHeadings
   * @returns
   */

  public postFormDataFile(url: string, body: any, contentType: string, headersIn = {}, excludeHeadings?: boolean): Observable<Object> {
    headersIn['Content-Type'] = contentType;
    const headers = !excludeHeadings
      ? new Headers({
          'Content-Type': contentType,
          Authorization: this.tokenLocal,
          'access-token': this.tokenLocal,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
          'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
          ...headersIn,
        })
      : new Headers({ 'Content-Type': contentType });
    return this.http
      .post(url, body, {
        ...headers,
        observe: 'response',
      })
      .pipe(
        map(res => {
          return res.body;
        }),
        catchError(error => {
          return this.handleError(error);
        })
      );
  }

  public put(
    url: string,
    body: any,
    headersIn = {},
    excludeHeadings?: boolean,
    headersType: httpHeadersType = httpHeadersType.ALLHEADERS
  ): Observable<Object> {
    headersIn['Content-Type'] = 'application/json; charset=UTF-8';
    return this.http.put(url, body, { headers: this.getHeaders(excludeHeadings, headersIn, headersType), observe: 'response' }).pipe(
      map(res => {
        return res.body;
      }),
      catchError(error => {
        return this.handleError(error);
      })
    );
  }

  public delete(
    url: string,
    headersIn = {},
    excludeHeadings?: boolean,
    headersType: httpHeadersType = httpHeadersType.ALLHEADERS
  ): Observable<Object> {
    headersIn['Content-Type'] = 'application/json; charset=UTF-8';
    return this.http.delete(url, { headers: this.getHeaders(excludeHeadings, headersIn, headersType), observe: 'response' }).pipe(
      map(res => {
        return res.body;
      }),
      catchError(error => {
        return this.handleError(error);
      })
    );
  }

  private handleError(error: HttpErrorResponse): Observable<any> {
    if (error.status === sharedHttpConstants.UNAUTHORIZED) {
      this.userDataService.setTokenLocal('');
    } else if (error.status === sharedHttpConstants.CONFLICT) {
      console.error('ERROR', 'mensaje incorrecto');
    } else if (error.status === sharedHttpConstants.INTERNAL_SERVER_ERROR || error.status === sharedHttpConstants.SERVICE_UNAVAILABLE) {
      console.error('ERROR', 'mensaje de interno de servidor');
    }
    return of(error);
  }
}
